import Report from '../models/Report';
import Statistic from '../models/Statistic';
import RestClient from './RestClient';

export type SupportIndicators = {
    pendingTriage: {
        count: number;
        ageHoursAvg: number | null;
        ageHoursMax: number | null;
    };
    createdToday: {
        count: number;
    };
    unanswered: {
        count: number;
        thresholdHours: number;
    };
};

class Statistics extends RestClient {
    constructor() {
        super({
            // rest config
            model: Statistic,
            entryPoint: 'statistics',
            // redux config
            resource: 'statistics',
            resources: 'statistics',
        });
    }

    getStatistics(params?: Array<string>) {
        const scopes = params?.length ? params : ["all"];
        // Prefer ?query=changes (OpenAPI). Avoid array serialization (?0=changes).
        return this.GET(`/${this.entryPoint}/overview`, { query: scopes.join(',') })
            .then(response => response.json())
            .then(json => {
                if (json.statistics) {
                    return { statistics: new Statistic(json.statistics) };
                }
                throw new Error(json.flash.error);
            });
    }

    getSupportIndicators(params?: { unanswered_hours?: number; project?: string; client?: string }) {
        return this.GET(`/${this.entryPoint}/support`, params || {})
            .then(response => response.json())
            .then(json => {
                if (json.support) {
                    return { support: json.support as SupportIndicators };
                }
                throw new Error(json.flash?.error || 'Failed to load support indicators');
            });
    }

    getReport(params?: AnyObj) {
        return this.GET(`/${this.entryPoint}/report`, params)
            .then(response => response.json())
            .then(json => {
                if (json.report) {
                    return { report: new Report(json.report) };
                }
                throw new Error(json.flash.error);
            });
    }
}

const StatisticsApi = new Statistics();

export default StatisticsApi;
